import { Component, computed, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppTab, ICompanyDocument } from '@okcargo-apps/shared-domain-ionic';
import { AnalyticsService } from '@okcargo-apps/shared-infrastructure-ionic';
import { Observable } from 'rxjs';
import { CompanyService } from '../../company';
import { FastpayInfoConditionsComponent } from '../fastpay-info-conditions/fastpay-info-conditions.component';

@Component({
  selector: 'lib-fastpay-info-modal',
  templateUrl: './fastpay-info-modal.component.html',
  styleUrls: ['./fastpay-info-modal.component.scss'],
  imports: [
    IonContent,
    IonCol,
    IonRow,
    IonGrid,
    IonFooter,
    IonTitle,
    IonIcon,
    IonButton,
    IonButtons,
    IonToolbar,
    IonHeader,
    TranslateModule,
    FastpayInfoConditionsComponent,
  ],
})
export class FastpayInfoModalComponent implements OnInit {
  private readonly modalCtrl = inject(ModalController);
  private readonly translate = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly companyService = inject(CompanyService);
  private readonly analyticsService = inject(AnalyticsService);

  public readonly expiredCompanyDocuments$: Observable<ICompanyDocument[]> =
    this.companyService.expiredOrNotUploadedDocuments$;

  private readonly expiredCompanyDocuments = toSignal(this.companyService.expiredOrNotUploadedDocuments$, {
    initialValue: [],
  });

  public readonly hasExpiredCompanyDocuments = computed(() => this.expiredCompanyDocuments().length > 0);

  public readonly buttonText = computed(() =>
    this.hasExpiredCompanyDocuments()
      ? this.translate.instant('fast_pay.manage_docs')
      : this.translate.instant('fast_pay.go_to_finished'),
  );

  // constructor() {}

  ngOnInit(): void {
    this.analyticsService.logPageView('fastpay-info-modal', {});
  }

  public async closeModalWithCancel(): Promise<boolean> {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  public async closeModalWithAccept(): Promise<boolean> {
    await this.modalCtrl.dismiss({ accepted: true }, 'confirm');
    const route = this.hasExpiredCompanyDocuments() ? ['/my-company'] : [`/tabs/${AppTab.FINISHED}`];
    this.router.navigate(route);
    return true;
  }
}
